import { create } from "zustand";
import { DETAIL_RACCORDEMENT } from "../Utils/constant";
import { findOne } from "../services/service";
export const useStoreRaccordement = create((set) => ({
  loading: false,
  data: null,
  getData: async (id) => {
    set({
      loading: true,
      data: [],
    });

    try {
      const getItems = await findOne(DETAIL_RACCORDEMENT, id);
      set({
        loading: false,
        data: getItems.data,
      });
    } catch (error) {
      set({
        loading: true,
        data: [],
      });
    }
  },
}));
